import { ApplicantType } from "shared/interfaces/misc";
import { isSubstrInStr } from "shared/utils/ui";

const COLORS = {
  incomeAndAssets: {
    verified: "#28BF8C",
    notVerified: "#FF8C6A",
  },
  deal: {
    decisionDropdown: {
      approve: "#78E2BF",
      conditionallyApprove: "#FFC2A8",
      conditionallyApproveV2: "#FFAF66",
      decline: "#FEA6A6",
    },
  },
  dealSetupSettingsModal: {
    text: "#2D2943",
  },
};

const MODALS = {
  // Property
  assignPropertyToPortfolio: "ASSIGN_PROPERTY_TO_PORTFOLIO_MODAL",
  customizePropertySettings: "CUSTOMIZE_PROPERTY_SETTINGS",
  uploadPropertyLogo: "UPLOAD_PROPERTY_LOGO",
  // Invite applicants
  inviteApplicants: "INVITE_APPLICANTS",
  // DealSetup
  dealSetupQuestions: "DEAL_SETUP_QUESTIONS",
  dealSetupAttachments: "DEAL_SETUP_ATTACHMENTS",
  // Integrations
  bluemoonConnectLicense: "BLUEMOON_CONNECT_LICENSE",
};

const ATTACHMENT_TYPES = {
  APPLICATION: "AP",
  UNVERIFIED_INCOME: "UI",
  UNVERIFIED_BACKGROUND: "UB",
};

const ACTIVE_DOCUMENTS_STEPS = [
  {
    label: "Document is assigned to the property",
  },
  {
    label: " Fields are setup at the property level",
  },
  {
    label: "Document is activated",
  },
];

export {
  COLORS,
  MODALS,
  ATTACHMENT_TYPES,
  ACTIVE_DOCUMENTS_STEPS,
};

export const UNIT_STATUSES = {
  NL: {
    key: "NL",
    label: "No listing",
  },
  AL: {
    key: "AL",
    label: "Active Listing",
  },
  OH: {
    key: "OH",
    label: "On Hold",
  },
  PL: {
    key: "PL",
    label: "Pending Lease",
  },
  RE: {
    key: "RE",
    label: "Rented",
  },
  NA: {
    key: "NA",
    label: "N/A",
  },
};

export const DOWNLOAD_STATUSES = {
  inProgress: "In Progress",
  completed: "Completed",
  failed: "Failed",
};

export const LEADS_CATEGORIES = [
  {
    key: "",
    apiKey: "",
    name: "All",
    count: 0,
  },
  { key: "prospect", apiKey: "prospect", name: "Prospect", count: 0 },
  { key: "guest", apiKey: "guest", name: "Guest", count: 0 },
];

export const LEADS_CATEGORY_TYPES = {
  ALL: "all",
  PROSPECT: "prospect",
  GUEST: "guest",
};

export const LEADS_CATEGORY_LABEL_INFO = {
  [LEADS_CATEGORY_TYPES.PROSPECT]: "Prospect Leads",
  [LEADS_CATEGORY_TYPES.GUEST]: "Guest Leads",
};

export const DEAL_CATEGORY_TYPES = {
  ALL: "all",
  APPROVED: "approved",
  PENDING: "pending",
  INCOMPLETE: "incomplete",
  REJECTED: "rejected",
};

export const DEAL_CATEGORY_LABEL_INFO = {
  [DEAL_CATEGORY_TYPES.APPROVED]: "Approved Applications",
  [DEAL_CATEGORY_TYPES.PENDING]: "Applications Awaiting Decision",
  [DEAL_CATEGORY_TYPES.INCOMPLETE]: "Applications in Progress",
  [DEAL_CATEGORY_TYPES.REJECTED]: "Rejected Applications",
};

export const DEAL_CATEGORIES = [
  {
    key: DEAL_CATEGORY_TYPES.ALL,
    apiKey: "",
    name: "All",
  },
  {
    key: DEAL_CATEGORY_TYPES.PENDING,
    apiKey: "pending",
    name: "Pending",
  },
  {
    key: DEAL_CATEGORY_TYPES.INCOMPLETE,
    apiKey: "incomplete",
    name: "Incomplete",
  },
  {
    key: DEAL_CATEGORY_TYPES.APPROVED,
    apiKey: "approved",
    name: "Approved",
  },
  {
    key: DEAL_CATEGORY_TYPES.REJECTED,
    apiKey: "rejected",
    name: "Rejected",
  },
];

const DEAL_CATEGORY_FILTERS = {
  APPLICATION_APPROVED: "APPLICATION APPROVED",
  APPLICATIONS_INCOMPLETE: "APPLICATIONS INCOMPLETE",
  APPLICATIONS_PARTIALLY_SUBMITTED: "APPLICATIONS PARTIALLY SUBMITTED",
  INVITES_SENT: "INVITES SENT",
  APPLICATION_PENDING: "APPLICATION PENDING",
  REQUESTED_MORE_INFO: "REQUESTED MORE INFO",
  APPLICATION_CANCELLED: "APPLICATION CANCELLED",
  DECLINED: "DECLINED",
  SENT_TO_ENTRATA: "SENT TO ENTRATA",
};

export const DEAL_CATEGORY_FILTERS_MAPPING = {
  [DEAL_CATEGORY_FILTERS.APPLICATION_APPROVED]: "Application Approved",
  [DEAL_CATEGORY_FILTERS.APPLICATIONS_INCOMPLETE]: "Applications in Progress",
  [DEAL_CATEGORY_FILTERS.APPLICATIONS_PARTIALLY_SUBMITTED]:
    "Applications Partially Submitted",
  [DEAL_CATEGORY_FILTERS.INVITES_SENT]: "Invites Sent",
  [DEAL_CATEGORY_FILTERS.APPLICATION_PENDING]: "Application Awaiting Decision",
  [DEAL_CATEGORY_FILTERS.REQUESTED_MORE_INFO]: "Requested More Info",
  [DEAL_CATEGORY_FILTERS.APPLICATION_CANCELLED]: "Application Cancelled",
  [DEAL_CATEGORY_FILTERS.DECLINED]: "Declined",
  [DEAL_CATEGORY_FILTERS.SENT_TO_ENTRATA]: "Sent to Entrata",
};

export const DEAL_OVERVIEW_VERSION = {
  V1: "V1",
  V2: "V2",
};

export const APPLICATION_AUDITS_QUERY = "getApplicationAudits";

export const APPLICANT_TYPES_LABEL = {
  [ApplicantType.APPLICANT]: "Applicant",
  [ApplicantType.GUARANTOR]: "Guarantor",
  [ApplicantType.OCCUPANT]: "Occupant",
};

export const ACTION_NOT_PERMITTED_MESSAGE =
  "You are not authorized to perform this action";

export const DEAL_ACTION_YARDI_SOURCE = "YRD";

// Pagination constants
export const PAGINATION = {
  DEALS_TO_MOVE_PAGE_SIZE: 50,
};
